import { Component, Input } from '@angular/core';

@Component({
  selector: 'eo-form-label',
  templateUrl: './eo-form-label.component.html',
  styleUrl: './eo-form-label.component.scss',
})
export class EoFormLabelComponent {
  @Input() formId?: string;
  @Input() label?: string;
  @Input() required?: boolean = false;
}
